"use client";

import React from "react";
import GenericSubstantiveProcedures from "../substantive-procedures/GenericSubstantiveProcedures";

interface ImpairmentSubstantiveProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

const WORKSPACE_NAME = "Impairment Testing";

export default function ImpairmentSubstantive({ onBack, setActiveSection }: ImpairmentSubstantiveProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
